import { multiply } from 'ramda'
import { baseSpacingUnit } from '@woorcs/design-tokens'

import { rem } from './units'

const multiplySpacing = multiply(baseSpacingUnit)

export const space = (x: number, relative = true): string | number =>
  relative ? rem(multiplySpacing(x)) : multiplySpacing(x)
